/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

import { SuperhumanPutAnswer, SuperhumanQuestion } from '@shared/models/Superhuman';

import { environment } from '../../../../environments/environment';
import { MobileReportsModel, Notification, PerformanceItem, ReportEndValues, TransactionItem } from '../models/Reporting';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {
  accountID: string;
  customerID: number;

  constructor(
    private http: HttpClient,
    private store: Store
  ) {
    this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentAccount)).subscribe((value) => {
      this.accountID = value.currentAccountDetail.id;
      this.customerID = value.customer.id;
    });
  }

  getEndValues(): Observable<{ customer: { end_values: ReportEndValues } }> {
    return this.http.get<{ customer: { end_values: ReportEndValues } }>(`${environment.apiUrl}/accounts/${this.accountID}/reports/end-values`);
  }

  getPerformanceGraph(): Observable<PerformanceItem[]> {
    return this.http
      .get<{
        data: { type: string; id: string; attributes: { reporting: PerformanceItem[] } }[];
      }>(`${environment.apiUrlV3}/performance_reports/${this.accountID}?range=''`)
      .pipe(map(({ data }) => data[0].attributes.reporting));
  }

  getTransactions(): Observable<{ report_transactions: TransactionItem[] }> {
    return this.http.get<{ report_transactions: TransactionItem[] }>(`${environment.apiUrl}/accounts/${this.accountID}/report-transactions`);
  }

  getNotifications(): Observable<{ meta: any; data: Notification[] }> {
    return this.http.get<{ data: Notification[]; meta: any }>(`${environment.apiUrlV3}/customer_notifications?filter[for_desktop]=true`);
  }

  markAsSeenNotification(notificationId: number): Observable<{ success: 'success' }> {
    return this.http.put<{ success: 'success' }>(`${environment.apiUrl}/notifications/${notificationId}`, {});
  }

  getReports(): Observable<MobileReportsModel> {
    return this.http.get<MobileReportsModel>(`${environment.apiUrl}/accounts/${this.accountID}/reports/mobile`);
  }

  getSuperHumanSurvey(): Observable<{ id: number; name: string; survey_questions: SuperhumanQuestion[] }> {
    return this.http.get<{ id: number; name: string; survey_questions: SuperhumanQuestion[] }>(
      `${environment.apiUrl}/accounts/${this.accountID}/survey/superhuman_v2/`
    );
  }

  saveSuperHumanSurvey(payload: { answers: SuperhumanPutAnswer[]; answered_from: string; submitted: boolean }): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${environment.apiUrl}/survey/superhuman_v2/answers`, payload);
  }
}
